module.exports = __webpack_public_path__ + "color.c7a33805ffda0d32bd2a.png";


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/assets/primeng/resources/images/color.png
// module id = ../../../../../src/assets/primeng/resources/images/color.png
// module chunks = styles